<template>
  <header class="header">
    <div class="header__wrapper"><TheNavbar /></div>
  </header>
</template>

<script>
import TheNavbar from '~/components/TheHeader/TheNavbar'

export default {
  name: 'TheHeader',
  components: {
    TheNavbar
  }
}
</script>

<style lang="scss">
.header {
  position: absolute;
  z-index: 20;
  top: 8px;
  right: 16px;
  left: 16px;

  &__wrapper {
    display: flex;
    align-items: center;
  }
}

@include media-min($tablet-width) {
  .header {
    width: 718px;
    margin: 0 auto;
  }
}

@include media-min($desktop-width) {
  .header {
    top: 16px;
    width: 1168px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// components/TheHeader/TheHeader.vue